// assets/kea-cart-gwp-threshold.js
(function () {
  if (window.__KEA_GWP_THRESHOLD_BOUND__) return;
  window.__KEA_GWP_THRESHOLD_BOUND__ = true;

  const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  const JSON_HEADERS = { "Content-Type": "application/json", Accept: "application/json" };

  const getDrawer = () => document.getElementById("mini-cart") || document.querySelector("cart-drawer");
  const cartGet = () => fetch(ROOT + "cart.js", { credentials: "same-origin" }).then((r) => r.json());

  const cartAddGift = (variantId, promoCode) => {
    const properties = { _auto_gwp: "1" };
    if (promoCode) properties["_promo_code"] = promoCode;
    return fetch(ROOT + "cart/add.js", {
      method: "POST", headers: JSON_HEADERS, credentials: "same-origin",
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1, properties }] }),
    });
  };

  const cartChangeByKey = (key, qty) => fetch(ROOT + "cart/change.js", {
    method: "POST", headers: JSON_HEADERS, credentials: "same-origin",
    body: JSON.stringify({ id: key, quantity: qty }),
  });

  function readConfig() {
    const drawer = getDrawer();
    if (!drawer) return null;
    const enabled = String(drawer.dataset.giftEnabled || "").toLowerCase() === "true";
    if (!enabled) return null;
    const variantId = parseInt(drawer.dataset.giftVariantId || "0", 10);
    const threshold = parseInt(drawer.dataset.giftThreshold || "0", 10);
    const rawPromos = String(drawer.dataset.giftPromoCode || "").toUpperCase();
    const requiredPromos = rawPromos.split(',').map(c => c.trim()).filter(Boolean);
    if (!variantId || !threshold) return null;
    return { variantId, threshold, requiredPromos };
  }

  function isGiftLine(li, variantId) {
    const id = Number(li?.id || li?.variant_id || 0);
    if (id !== Number(variantId)) return false;
    return (li.properties && (li.properties._auto_gwp === "1" || li.properties["_auto_gwp"] === "1"));
  }

  function lineFinalCents(li) {
    if (typeof li.final_line_price === "number") return li.final_line_price;
    const qty = typeof li.quantity === "number" ? li.quantity : 1;
    const perItem = typeof li.final_price === "number" ? li.final_price : typeof li.price === "number" ? li.price : 0;
    return perItem * qty;
  }

  function subtotalExcludingGift(cart, variantId) {
    const total = Number(cart.total_price || 0); 
    const giftTotal = (cart.items || []).reduce((sum, li) => isGiftLine(li, variantId) ? sum + lineFinalCents(li) : sum, 0);
    return Math.max(0, total - giftTotal);
  }

  function refreshDrawer() {
    document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
  }

  let busy = false;

  async function ensureGiftState(reason) {
    if (window.__KEA_UPDATING_GWP) return; 

    const cfg = readConfig();
    if (!cfg || busy) return;
    busy = true;

    try {
      const cart = await cartGet();
      const subtotal = subtotalExcludingGift(cart, cfg.variantId);
      
      let activePromoCode = null;
      let hasRequiredPromo = true;

      if (cfg.requiredPromos.length > 0) {
        const appliedCodes = [];
        (cart.cart_level_discount_applications || []).forEach(a => { if (a.title) appliedCodes.push(String(a.title).toUpperCase()); });
        (cart.discount_applications || []).forEach(a => { if (a.title) appliedCodes.push(String(a.title).toUpperCase()); });
        (cart.items || []).forEach(item => {
          (item.line_level_discount_allocations || []).forEach(alloc => {
            if (alloc.discount_application && alloc.discount_application.title) appliedCodes.push(String(alloc.discount_application.title).toUpperCase());
          });
        });
        activePromoCode = cfg.requiredPromos.find(code => appliedCodes.includes(code));
        hasRequiredPromo = !!activePromoCode;
      }

      const shouldHave = subtotal >= cfg.threshold && hasRequiredPromo;
      const giftLines = (cart.items || []).filter((li) => isGiftLine(li, cfg.variantId));
      let changed = false;

      if (shouldHave) {
        if (giftLines.length === 0) {
          await cartAddGift(cfg.variantId, activePromoCode || "");
          changed = true;
        } else {
          for (let i = 1; i < giftLines.length; i++) { await cartChangeByKey(giftLines[i].key, 0); changed = true; }
          if (giftLines[0].quantity !== 1) { await cartChangeByKey(giftLines[0].key, 1); changed = true; }
        }
      } else {
        for (const g of giftLines) { await cartChangeByKey(g.key, 0); changed = true; }
      }

      if (changed) refreshDrawer();
    } catch (e) {
      console.warn("[KEA GWP] ensureGiftState error", reason, e);
    } finally {
      busy = false;
    }
  }

  const scheduleEnsure = (() => {
    let t = null;
    return (reason) => { clearTimeout(t); t = setTimeout(() => ensureGiftState(reason), 400); };
  })();

  function init() {
    scheduleEnsure("init");
    document.addEventListener("cart:updated", () => scheduleEnsure("cart:updated"));
    document.addEventListener("ajaxCart:requestComplete", () => scheduleEnsure("ajaxCart:requestComplete"));
    document.documentElement.addEventListener("cart:refresh", () => scheduleEnsure("cart:refresh"));
    document.addEventListener("shopify:section:load", () => scheduleEnsure("shopify:section:load"));

    const currentFetch = window.fetch;
    if (!currentFetch.__kea_gwp_patched__) {
      const patchedFetch = async function (...args) {
        try {
          const url = typeof args[0] === "string" ? args[0] : args[0] && args[0].url;
          
          // --- INTERCEPTION MAGIQUE AVANT LA VALIDATION DU CODE ---
          if (url && url.includes("/cart/update.js") && args[1] && args[1].body) {
            let discountCode = "";
            if (typeof args[1].body === "string") {
              try {
                discountCode = JSON.parse(args[1].body).discount;
              } catch (e) {
                const params = new URLSearchParams(args[1].body);
                discountCode = params.get("discount");
              }
            }

            if (discountCode) {
              const submittedCodes = discountCode.split(",").map(s => s.trim().toUpperCase());
              const cfg = readConfig();
              
              if (cfg) {
                const matchingCode = submittedCodes.find(c => cfg.requiredPromos.includes(c));
                if (matchingCode) {
                  window.__KEA_UPDATING_GWP = true; // Verrouille
                  const currentCart = await fetch(ROOT + "cart.js").then(r => r.json());
                  let subtotal = 0;
                  let giftAlreadyInCart = false;
                  
                  (currentCart.items || []).forEach(item => {
                    if (String(item.variant_id) === String(cfg.variantId) || String(item.id) === String(cfg.variantId)) {
                      giftAlreadyInCart = true;
                    } else {
                      subtotal += (item.final_line_price !== undefined ? item.final_line_price : (item.price * item.quantity));
                    }
                  });

                  // Ajout du cadeau silencieusement avant validation
                  if (subtotal >= cfg.threshold && !giftAlreadyInCart) {
                    await cartAddGift(cfg.variantId, matchingCode);
                  }
                  window.__KEA_UPDATING_GWP = false; // Déverrouille
                }
              }
            }
          }
        } catch (err) {
          window.__KEA_UPDATING_GWP = false;
        }

        // Laisse le reste de l'application (et discount-drawer.js) faire son travail
        const res = await currentFetch.apply(this, args);

        try {
          const url = typeof args[0] === "string" ? args[0] : args[0] && args[0].url;
          if (url && /\/cart\/(add|change|update|clear)\.js/.test(url)) {
            scheduleEnsure("fetch:" + url);
          }
        } catch (_) {}
        return res;
      };
      patchedFetch.__kea_gwp_patched__ = true;
      window.fetch = patchedFetch;
    }

    document.addEventListener("click", async (e) => {
      const btn = e.target.closest('button[name="checkout"], input[name="checkout"], a[href$="/checkout"]');
      if (!btn || !btn.closest("#mini-cart, cart-drawer")) return;
      const cfg = readConfig();
      if (!cfg) return;
      e.preventDefault();
      try { window.__KEA_UPDATING_GWP = true; await ensureGiftState("before-checkout"); window.__KEA_UPDATING_GWP = false;} catch (_) {}
      window.location.assign(ROOT + "checkout");
    });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();